
var moduleHubSportWrapper = require('./hub-sports-wrapper');

var moduleHubSport = {
    
    
    options: {
        filteredList: "#sportsAdviceFilteredList",
        carouselNav: "#sportsAdviceCarouselNav",
        charCountEn: 3,
        charCountZh: 1,
        noSportsContainerID: 'no-sports'
    },
    
    init: function() {
        // Call every functions you need when your method is called.  
        
        this.wrapper = $('html');
      
        moduleHubSport.$sportsCarousel = moduleHubSport.wrapper.find('#container-floor-hs-categories .sports-advice-carousel-hub');
        moduleHubSport.$sportsAdviceFilter = moduleHubSport.wrapper.find('#container-floor-hs-categories #sportsAdviceFilter');
        moduleHubSport.nothingFoundPhrase = moduleHubSport.$sportsAdviceFilter.data('nothing-found-text') || 'there is no result';
        moduleHubSport.$sportsAdviceFilter.closest('form').attr('autocomplete', 'false');
         
        moduleHubSport.$filteredList = $(moduleHubSport.options.filteredList);

        moduleHubSport.initFilters();
        
        moduleHubSportWrapper.init(moduleHubSport.$sportsCarousel);
        moduleHubSport.hslistletters();
        
        moduleHubSport.createListOfSports();

        $(function(){
            moduleHubSport.$sportsCarousel.scrollLeft(0);

            if($('html').attr('lang') !== 'zh'){
                moduleHubSport.setWrapperHeight();
            }
        
            moduleHubSport.attachSportsFilterMethods();
        });


        
    },

    hslistletters: function(){

      var letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

      moduleHubSport.listletterhub = moduleHubSport.wrapper.find('#container-floor-hs-categories .hs-list-letters');

      // Iterates overs alphabet
      letters.map(function(letter) {

        var isPresent = $('.letter a[name="'+letter+'"]').length

        // Apply good class & href
        var href = isPresent ? 'href="#'+letter+'"' : '';
        var className = isPresent ? '' : 'disabled';

         moduleHubSport.listletterhub.append('<a '+href+' class="hs-list-letters__link '+className+'" >'+ letter + '</a>');

      });


      $('.hs-list-letters a').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var heightNavbar = heightNavbar = $('.hs-bloc-letters.navbar').height();
        var heightHeader = $('#header').height()
        var letter = $(this).attr('href').replace('#', '');
        var $rowLetter = $('a[name="'+letter+'"]').closest('.hs-body-sports');
        var offset = -(heightNavbar+ heightHeader)

        if (!$('.hs-bloc-letters.navbar').hasClass('affix'))
          offset = offset - 80;

        $(window).scrollTo($rowLetter, 200, {offset : offset} )
      })

    },
    
    initFilters: function() {
        var moduleHubSport = this;
        this.wrapper = $('html');
        
        moduleHubSport.$sportsAdviceFilter = moduleHubSport.wrapper.find('#sportsAdviceFilter');
        moduleHubSport.$sportsAdviceFilter.closest('form').attr('autocomplete', 'false');
        moduleHubSport.$filteredList = $(moduleHubSport.options.filteredList);
        
        
        moduleHubSport.$carouselNav = $(moduleHubSport.options.carouselNav);
        
        moduleHubSport.$filteredList.on( 'mousewheel DOMMouseScroll', function (e) {
            
            var e0 = e.originalEvent,
            delta = e0.wheelDelta || -e0.detail;
            
            if ((this.scrollTop === 0 && delta > 0) || ((this.scrollTop + this.offsetHeight) >= this.scrollHeight && delta < 0)) {
                e.preventDefault();
            }
            
        });
        
        moduleHubSport.$sportsCarousel.on( 'mousewheel', function (e) {
            var e0 = e.originalEvent,
            delta = e0.deltaX || e0.wheelDeltaX;
            
            if ((this.scrollLeft === 0 && delta < 0) || ((this.scrollLeft + this.offsetWidth) === this.scrollWidth && delta > 0)) {
                e.preventDefault();
            }
        });
        
        
    },
    
    
createListOfSports: function() {
    
    if(this.$filteredList.length > 0){
        var sportsAdviceFilteredList = '<ul>';
        
        if (moduleHubSportWrapper.orderedSportsArray) {
            moduleHubSportWrapper.orderedSportsArray.each(function(){
                
                sportsAdviceFilteredList += '<li>';
                sportsAdviceFilteredList += $(this)[0].outerHTML;
                sportsAdviceFilteredList += '</li>';
            });
        }
        
        moduleHubSport.$filteredList.append(sportsAdviceFilteredList).addClass('hidden');
    }
},

initJqueryFilter: function(){
    // /*https://gist.github.com/oziks/3664787*/
    $.expr[':'].containsChar = function(a, i, m) {

      var element = $(a).text().removeDiacritics();
      var search = m[3].removeDiacritics();

      if (!search) return false;
      return new RegExp(search,"i").test(element);
    };
},

getSportGroupXposition: function(sportGroup){
     return sportGroup[0].getBoundingClientRect().left - moduleHubSport.$sportsCarousel[0].getBoundingClientRect().left;

},

setWrapperHeight: function(){
        // var _this = this;

        setTimeout(function(){

        var sportsCarouselWrapperHeight = moduleHubSport.$sportsCarousel.find('.sport-groups-wrapper').outerHeight();

        uxDynamicStyles.appendCssStylesArrayToHeader({
            uniqueId : 'sportsCarouselDynStyles1',
            selectors : [
            '.hs-body'
            ],
            properties : [
                //'height: '+ (sportsCarouselWrapperHeight) + 'px;'
            ]
            }
        );

        uxDynamicStyles.appendCssStylesArrayToHeader({
            uniqueId : 'sportsCarouselDynStyles2',
            selectors : [
            '.container-floor-hs-categories .sports a'
            ],
            properties : [
                'height: '+ (sportsCarouselWrapperHeight/2) + 'px;'
            ]
            }

        );

        },0);
},

highlightSearch: function(string, phrase){
    return string.replace(new RegExp("(" + phrase + ")", "gi") , "<b>$1</b>");
},

attachSportsFilterMethods: function(){

    var  search, $target;
    moduleHubSport.initJqueryFilter();
    var charCount = $('html').attr('lang') === 'zh' ? moduleHubSport.options.charCountZh : moduleHubSport.options.charCountEn;

   

    moduleHubSport.$sportsAdviceFilter.on("focus input",function () {
        search = $(this).val();

        $target = moduleHubSport.$filteredList.find('li');
        $(document).on('click.close-sports-filter-list', function(){
          if(!moduleHubSport.$sportsAdviceFilter.is(':focus')){
            moduleHubSport.$filteredList.addClass('hidden').attr('aria-hidden', 'true');
          }
        });

        if (search && search.length >= charCount) {
          /* show list */

          moduleHubSport.$filteredList.removeClass('hidden').attr('aria-hidden', 'false');
          $target.removeClass('last-child').addClass('hidden').attr('aria-hidden', 'true');

          var matchingSportsArray = $target.find('.text:containsChar("' + search + '")');
          if(matchingSportsArray.length > 0){

            moduleHubSport.$filteredList.find('#'+moduleHubSport.options.noSportsContainerID).remove();
            
            matchingSportsArray.each(function(index){
              if( index+1 === matchingSportsArray.length){
                $(this).closest('li').addClass('last-child');
              }
              $(this).closest('li').removeClass('hidden').attr('aria-hidden', 'false');
              $(this).html(moduleHubSport.highlightSearch($(this).text(), search));
            });
            
          } else {
            if(moduleHubSport.$filteredList.find('#'+moduleHubSport.options.noSportsContainerID).length === 0) {
              moduleHubSport.$filteredList.append('<div id="'+moduleHubSport.options.noSportsContainerID+'">'+moduleHubSport.nothingFoundPhrase+'</div>');
            }
          }

        } else {

          /* hide list */

          $target.find('.text').each(function(){
            $(this).html($(this).text());
          });

          $target.removeClass('hidden').attr('aria-hidden', 'false');
          moduleHubSport.$filteredList.addClass('hidden').attr('aria-hidden', 'true');

          $(document).off('click.close-sports-filter-list');

        }
    });





},

}

module.exports = moduleHubSport;


// WEBPACK FOOTER //
// ./src/modules-es5/pages/hub/hub-sports.js